import React from 'react'
import Logo from "../assets/Logo transparent.png"
import { Link } from 'react-router-dom'
import { FaFacebook, FaInstagram } from 'react-icons/fa'
import { FaXTwitter  } from 'react-icons/fa6'
const Footer = () => {
  return (
    <div>
        <div className=" text-black pt-4 pb-2 px-4">
    <div className="mx-auto px-4 container overflow-hidden flex flex-col lg:flex-row justify-between">
        <div className='w-1/3 mr-4'>
            <Link to="/" >
            <img src={Logo} className="w-100 ml-4 lg:ml-0" alt="logo" />
            </Link>
        </div>
        
        <div className="w-2/3 block sm:flex text-sm mt-6 lg:mt-0">
            <ul className="text-black list-none p-0 font-thin flex flex-col text-left w-full">
                <li className="inline-block py-2 px-3 text-black uppercase font-extrabold tracking-widest">Resources</li>
                <li><Link to="/about" className="inline-block py-2 px-3 text-black hover:text-yellow-600 font-normal no-underline">About us</Link></li>
                <li><Link to="/why-choose-us" className="inline-block py-2 px-3 text-black hover:text-yellow-600 font-normal no-underline">Why Choose Us?</Link></li>
                <li><Link to="/service" className="inline-block py-2 px-3 text-black hover:text-yellow-600 font-normal no-underline">Services</Link></li>
                
            </ul>
            <ul className="text-black list-none p-0 font-thin flex flex-col text-left w-full">
                <li className="inline-block py-2 px-3 text-black uppercase font-extrabold tracking-widest">Help</li>
                <li><Link to="/contact" className="inline-block py-2 px-3 text-black hover:text-yellow-600 font-normal no-underline">Contact us</Link>
                </li>
                <li><Link to="#" className="inline-block py-2 px-3 text-black hover:text-yellow-600 font-normal no-underline">Privacy policy</Link>
                </li>
                <li><Link to="#" className="inline-block py-2 px-3 text-black hover:text-yellow-600 font-normal no-underline">Terms of Service</Link></li>
            </ul>
        </div>
        <div className='w-3/3'>
        <div className="text-black flex flex-col w-full">
                <div className="inline-block py-2 px-3 text-black uppercase font-medium tracking-wide">Follow Us</div>
                <div className="flex pl-4 justify-start mt-2">
                    <Link tos="block items-center text-gray-300 hover:text-black mr-6 no-underline" to="#">
                       <FaFacebook size={20} className='m-2' />
                    </Link>
                    <Link tos="block items-center text-gray-300 hover:text-black mr-6 no-underline" to="#">
                        <FaInstagram size={20} className='m-2'/>
                    </Link>
                    <Link tos="block items-center text-gray-300 hover:text-black no-underline" to="#">
                        <FaXTwitter size={20} className='m-2'/>
                    </Link>
                </div>
            </div>
        </div>
    </div>
</div>

<div className="pt-4 mt-4 text-gray-600 border-t border-gray-800 text-center"> ©2025  All rights reserved.</div>
    </div>
  )
}

export default Footer
